import { useContext } from 'react'
import { AnalyticsContext } from 'contexts'

export default function useAuth() {
  return useContext(AnalyticsContext)
}
